import styled from "styled-components";


export const Layout = styled.div`
  position: absolute;
  //margin-left: -100%;
  top: 20px;
  background: #fff;
`;

export const Image = styled.img`
  display: block;
`
export const Description = styled.div`

  font-weight: bold;
  text-align: center;
  font-size: 14px;
  color: #2d2d2d;
  word-wrap: break-word;
  word-break: normal;
  line-height: 1.4;
  //text-overflow: ellipsis;
`
export const Footer = styled.div`
    //width: 100%;
  margin-top: 2px;
`;

export const LinkGroup = styled.div`
    width: 100%;
  overflow: hidden;
  margin-top: 10px;
`;
export const Link = styled.a<{
    light?: boolean
}>`
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  font-weight: bold;
  display: block;
  color: ${(props) => props.light ? "rgb(215 59 59)": "#333"};
  text-decoration: underline;
  text-underline-offset: 4px;
  line-height: 24px;
  //margin-bottom: 4px;
  //margin-bottom: 10px;
  //border-bottom-width: 1px;
  //border-bottom-style: solid;
  //border-bottom-color: ${(props) => props.light ? "rgb(215 59 59)": "#333"};
  //&:focus, &:hover {
  //  color: rgba(#333, 0.5);
  //}  
`;